import { combineReducers } from 'redux'
import auth from './auth'
import Player from './player'
import cloudAccounts from './cloud-accounts-reducers'
import analytics from './analytics-reducers'
import cloudFilesSystem from './cloud-files-system-reducers'
import localFilesSystem from './local-files-system-reducers'
import s3Direct from './s3-direct-reducers'
import slack from './slack-reducer'
import fileCatalyst from './file-catalyst-reducers'
import alerts from './alerts'
import roles from './roles'
import apiKey from './api-key'
import syncInfo from './sync-info'
import syncInfoWasabi from './sync-info-wasabi'
import contentAlert from './content-alert'
import migrations from './migrations'
import desktopAuth from './desktop/auth'

export default combineReducers({
  auth,
  cloudAccounts,
  cloudFilesSystem,
  localFilesSystem,
  s3Direct,
  slack,
  fileCatalyst,
  analytics,
  alerts,
  roles,
  apiKey,
  syncInfo,
  syncInfoWasabi,
  contentAlert,
  migrations,
  Player,
  desktopAuth,
})
